"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _VerificationRequiredContainer = _interopRequireDefault(require("../../VerificationRequired/VerificationRequiredContainer"));
var _depositWithdrawalSelectors = require("../../../redux/selectors/depositWithdrawalSelectors");
var _positionSelectors = require("../../../redux/selectors/positionSelectors");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _WithdrawFormComponent = _interopRequireDefault(require("./WithdrawFormComponent"));
var _withdrawActions = require("../../../redux/actions/withdrawActions");
var _store = _interopRequireDefault(require("../../../redux/store"));
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _config = _interopRequireDefault(require("../../../config"));
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formSelector = (0, _reduxForm.formValueSelector)('createWithdraw');
var closeSidePane = function closeSidePane() {
  return _store["default"].dispatch((0, _sidePaneActions.closeWithdrawSidePane)());
};
var mapStateToProps = function mapStateToProps(state) {
  var products = (0, _depositWithdrawalSelectors.productsListSelector)(state);
  var positions = (0, _positionSelectors.positionSelector)(state);
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    disableWithdraw = _kycVerificationLevel.disableWithdraw;
  return {
    disableWithdraw: disableWithdraw,
    products: products,
    withdrawInfo: state.withdraw,
    positions: positions,
    amountValue: formSelector(state, 'Amount'),
    selectedProductId: formSelector(state, 'ProductId'),
    hideFees: !!_config["default"].global.hideFees,
    VerificationRequiredComponent: /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
      disabled: disableWithdraw,
      onClick: closeSidePane
    }),
    selectedProductVerificationLevelConfig: (0, _productsSelectors.selectedProductVerificationLevelConfig)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectWithdrawProduct: function selectWithdrawProduct(productId) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplates)(productId));
    },
    selectWithdrawTemplate: function selectWithdrawTemplate(ProductId, AccountProviderId) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplate)(ProductId, AccountProviderId));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount, AccountProviderId) {
      return dispatch((0, _withdrawActions.getWithdrawFee)(productId, amount, AccountProviderId));
    },
    submitWithdraw: function submitWithdraw(payload) {
      return dispatch((0, _withdrawActions.createWithdrawTicket)(payload));
    }
  };
};
var WithdrawFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WithdrawFormComponent["default"]);
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'createWithdraw',
  onSubmit: function onSubmit() {}
})(WithdrawFormContainer);